import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { BsTable } from "react-icons/bs";
import { FaList } from "react-icons/fa";

import {
  Flex,
  Spacer,
  Divider,
  Text,
  Icon,
  Grid,
  GridItem,
  Box,
} from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";
import CardCategoria from "./CardCategoria";
import ListItem from "./ListItem";
import VisualizarAnexos from "./VisualizarCategoria";

import AnexosSAService from "../../../../main/services/AnexosSAService";
import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";
import { anexosFunc, criancaFunc } from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";
import { handleRestrictionAnexoServico } from "../../../utils/handleRestrictionAnexoServico";

const AnexosServicoAcolhimento = () => {
  const { id } = useParams();

  const [data, setData] = useState();
  const [dataSA, setDataSA] = useState();
  const [categorias, setCategorias] = useState();
  const [modoCard, setModoCard] = useState(true);
  const [selectedCategoriaId, setSelectedCategoriaId] = useState(-1);
  const [selectedCategoria, setSelectedCategoria] = useState();
  const { roleKeycloack, user } = useAuthProvider();

  useEffect(() => {
    AnexosSAService.listarCategorias(id)
      .then((res) => {
        setData(res.data);
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data.status === 404) {
            console.log(erro);
          }
        }
      });
    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setDataSA(res.data);
      })
      .catch((error) => console.log(error));
  }, [id]);

  useEffect(() => {
    if (data && dataSA) {
      let tempCategorias = [];
      if (dataSA.tipoServicoAcolhimento.regime === "SAF") {
        tempCategorias = data.filter(
          (categoria) =>
            categoria[1] !== "Oficio de Pessoa em Cumprimento de Pena" &&
            categoria[1] !== "Termo do Voluntariado"
        );
      } else {
        tempCategorias = [...data];
      }
      if (dataSA.naturezaServico === "publica") {
        tempCategorias = tempCategorias.filter(
          (categoria) =>
            categoria[1] !== "Estatuto da Entidade" &&
            categoria[1] !== "Registro no CMDCA" &&
            categoria[1] !== "Inscrição no CMAS"
        );
      }

      tempCategorias = handleRestrictionAnexoServico(
        tempCategorias,
        roleKeycloack
      );

      setCategorias(tempCategorias);
    }
  }, [data, dataSA, roleKeycloack]);

  return roleKeycloack &&
    (roleKeycloack.includes(anexosFunc.anexoServicoVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(dataSA?.idPessoaJuridica))) ? (
    categorias ? (
      selectedCategoriaId === -1 ? (
        <Flex
          bgColor="#FFF"
          p="20px 20px 40px 20px"
          mt="15px"
          borderRadius="16px"
          flexDir="column"
        >
          <Flex>
            <Text
              fontWeight={700}
              fontSize="16px"
              lineHeight="21.6px"
              color="#169499"
            >
              {"Anexos".toUpperCase()}
            </Text>
            <Spacer />
            <Icon
              aria-label="Modo card"
              color={modoCard ? "#797A80" : "#CCCCCC"}
              as={BsTable}
              boxSize="24px"
              _hover={{ cursor: "pointer" }}
              onClick={() => setModoCard(true)}
            />
            <Icon
              aria-label="Modo lista"
              color={modoCard ? "#CCCCCC" : "#797A80"}
              as={FaList}
              ml="15px"
              boxSize="24px"
              _hover={{ cursor: "pointer" }}
              onClick={() => setModoCard(false)}
            />
          </Flex>

          <Divider orientation="horizontal" mt="15px" />
          {modoCard ? (
            <Grid
              mt="30px"
              templateColumns={{
                base: "repeat(1, 1fr)",
                md: "repeat(2, 1fr)",
                lg: "repeat(3, 1fr)",
              }}
              gap="25px"
            >
              {categorias.map((categoria) => {
                return (
                  <GridItem colSpan={1}>
                    <CardCategoria
                      key={categoria[0]}
                      categoria={categoria}
                      setCategoriaId={setSelectedCategoriaId}
                      setCategoria={setSelectedCategoria}
                    />
                  </GridItem>
                );
              })}
            </Grid>
          ) : (
            <Flex flexDir="column">
              {categorias.map((categoria) => {
                return (
                  <ListItem
                    key={categoria[0]}
                    idCategoria={categoria[0]}
                    categoria={categoria[1]}
                    numArquivos={categoria[2].length}
                    files={categoria[2]}
                  />
                );
              })}
            </Flex>
          )}
        </Flex>
      ) : (
        <VisualizarAnexos
          categoria={selectedCategoria}
          setCategoriaId={setSelectedCategoriaId}
        />
      )
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={4}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default AnexosServicoAcolhimento;
